import classnames from "classnames";
import React, { ReactNode } from "react";
import { LazyloadImage } from "src/components";
import globalTheme, { media } from "src/theme";
import { IProduct } from "src/types/product";
import styled from "styled-components";

import { ITheme } from "../types";

interface IImmageContainer {
  imageMaxHeight?: number;
}

const ImageContainer = styled.div<IImmageContainer>`
  height: ${({ imageMaxHeight }: IImmageContainer): number =>
    imageMaxHeight ? imageMaxHeight : 290}px;

  ${media.tablet} {
    width: 100%;
    height: 100%;
    text-align: center;
  }
`;

interface IImage {
  imageMaxHeight?: number;
  theme?: ITheme;
}

const Image = styled.img<IImage>`
  background-color: ${globalTheme.colors.white};
  height: 100%;
  margin: 0 auto;
  cursor: pointer;
  ${({ theme }: IImage): string => (theme === "mini" ? "max-width: 80%" : "")}

  &.out-of-stock {
    opacity: 0.22;
  }

  ${media.tablet} {
    object-fit: contain;
    width: 70%;
    margin: auto;
  }
`;

interface IProps extends ITheme {
  isOutOfStockClassname: { "out-of-stock": boolean };
  product: IProduct;
  imageMaxHeight?: number;
  handleClick?: () => void;
  children?: ReactNode;
}
const ProductImage = ({
  isOutOfStockClassname,
  product,
  imageMaxHeight,
  handleClick,
  children,
  theme,
}: IProps): JSX.Element => {
  return (
    <ImageContainer imageMaxHeight={imageMaxHeight} className="image-wrapper">
      <LazyloadImage height={imageMaxHeight}>
        <Image
          className={classnames(isOutOfStockClassname)}
          src={product.image}
          imageMaxHeight={imageMaxHeight}
          onClick={handleClick}
          alt={product.name}
          theme={theme}
        />
      </LazyloadImage>
      {children}
    </ImageContainer>
  );
};
export default ProductImage;
